import type { MultiMeterBarChartTooltipVariant } from './types/multi-meter-bar-chart.js';
import type {
  MultiMeterBarChartSegmentData,
  MultiMeterBarChartState,
  MultiMeterBarTooltipState,
} from './types/state.js';
import type { MappedObject } from '../../core/types/helpers/mapped-object.js';

export const INITIAL_STATE: Readonly<MultiMeterBarChartState> = Object.freeze({
  segments: [],
  visibleSegments: new Map(null) as Map<string, MultiMeterBarChartSegmentData>,
  tooltip: {} as MultiMeterBarTooltipState,
});

export const TOOLTIP_VARIANT = Object.freeze<
  MappedObject<MultiMeterBarChartTooltipVariant>
>({
  Shared: 'shared',
  Single: 'single',
});

export const MULTIMETER_BAR_CHART_ARIA_LABEL = 'Multi Meter Bar Chart';
